/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MobilePlatform {
  Windows = 'Windows',
  Ios = 'Ios',
  Android = 'Android',
}
